export const v21Properties = [
  "date",
  "scheduledTime",
  "arrivalTimeFrom",
  "arrivalTimeTo",

  "senderName",
  "senderAddress",
  "senderBuildingNumber",
  "senderPhone",
  "senderEmail",
  "senderNote",

  "recipientName",
  "recipientAddress",
  "buildingNumber",
  "recipientPhone",
  "recipientEmail",
  "dropOffNote",

  "teamName",
  "driverName",

  "parcelValue",
  "parcelWeight",
  "parcelLength",
  "parcelHeight",
  "parcelWidth",

  "orderReferenceId",
]
